<template>
  <div class="basic">
    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">
          掌上信息:
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <template>
            <el-radio v-model="radio" label="1">启用</el-radio>
            <el-radio v-model="radio" label="2">禁用</el-radio>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">
          免审核：
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <template>
            <el-radio v-model="radio" label="1">启用</el-radio>
            <el-radio v-model="radio" label="2">禁用</el-radio>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">
          发帖定位：
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <template>
            <el-radio v-model="radio" label="1">强制开启</el-radio>
            <el-radio v-model="radio" label="2">默认开启</el-radio>
            <el-radio v-model="radio" label="3">默认关闭</el-radio>
          </template>
        </div>
      </el-col>
    </el-row>
    
    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">
          帖子默认排序：
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          <template>
            <el-radio v-model="radio" label="1">按发帖时间</el-radio>
            <el-radio v-model="radio" label="2">按浏览数量</el-radio>
            <el-radio v-model="radio" label="3">按分享数量</el-radio>
            <el-radio v-model="radio" label="4">按点赞数量</el-radio>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">
          发帖限制：
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content setLine">
          <el-input v-model="input1" size="small">
            <template slot="prepend">每人发帖总数</template>
          </el-input>
          <el-input v-model="input1" size="small">
            <template slot="prepend">个，每人每日发帖数</template>
          </el-input>
        </div>
        <div class="hint">个人发帖的数量限制，不填则无限制。</div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">
          虚拟数据：
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content setLine">
          <el-input placeholder="100" v-model="input1" size="small">
            <template slot="prepend">浏览</template>
          </el-input>
          <el-input placeholder="120" v-model="input1" size="small">
            <template slot="prepend">发布</template>
          </el-input>
          <el-input placeholder="21" v-model="input1" size="small">
            <template slot="prepend">点赞</template>
          </el-input>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">
          浏览增量：
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content setLine">
          <el-input placeholder="5" v-model="input1" size="small">
            <template slot="prepend">最大</template>
          </el-input>
          <el-input placeholder="1" v-model="input1" size="small">
            <template slot="prepend">最小</template>
          </el-input>
        </div>
        <div class="hint">每次刷新页面增加的浏览量，在最大与最小值之间随机增加.</div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">
          平台备注：
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content">
          <template>
            <el-input v-model="input" placeholder="请输入标题" size="small"></el-input>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">
          免责声明：
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content">
          <template>
            <el-input v-model="input" placeholder="请输入标题" size="small"></el-input>
          </template>
        </div>
        <div class="hint">默认内容为：本平台发布的所有信息展示，内容本身与平台本身无关，平台不负任何责任。</div>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="issue">
      <el-col :span="5" :offset="2">
        <div class="grid-content">
          <el-button size="small" type="primary" @click="issue">提交</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      input1: "",
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      radio: "1",
      imageUrl: "", //图片地址
      input: "",
      dataArray: "",
      listData: [], //列表
      page: 1,
      total: 0,
      loading: false, //页面loading
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      multipleSelection: [],
      // 编辑器
      isClear: false,
      detail: "",
    };
  },
  mounted() {},
  methods: {
    // 编辑器
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    issue() {
      this.$router.push({
        path: "/apply/forum/18/lanternSlide"
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.basic {
  padding: 10px 25px;
  .grid-content {
    min-width: 80px;
    min-height: 32px;
    line-height: 32px;
  }
  .setLine {
    display: flex;
    flex-direction: row;
  }
  .hint {
    padding: 10px 0;
    color: #909399;
  }
  .align_right {
    text-align: right;
    font-size: 14px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .issue {
    padding: 10px 0 30px;
  }
}
</style>

<style lang="scss">
.basic {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}

</style>
